export enum StudentMyLearningQuizTabStatus {
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETE = 'COMPLETED',
	ENROLLED = 'ENROLLED',
	SUBMITTED = "submitted",
	AUTO_SUBMITTED = "auto submitted",
	NOT_SUBMITTED = "not submitted",
}